module.exports = __webpack_public_path__ + "img/fold.60395b9b.webp";